export default __webpack_public_path__ + "static/media/iran_itex.9f80ef62.jpg";